import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCloseIcon({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 1.25a.75.75 0 010 1.5H3a.25.25 0 00-.25.25v10c0 .14.11.25.25.25h10c.14 0 .25-.11.25-.25V9.5a.75.75 0 111.5 0V13c0 .97-.78 1.75-1.75 1.75H3c-.97 0-1.75-.78-1.75-1.75V3c0-.97.78-1.75 1.75-1.75zm5.68.97l.4.4c.17.18.17.45 0 .61L8.45 8.74l2.68-.07c.24 0 .44.19.43.43v.56c0 .24-.19.43-.42.43H6.5a.43.43 0 01-.43-.43V5.03c0-.24.2-.43.43-.43h.56c.24 0 .43.2.43.44l-.07 2.7 5.65-5.52a.43.43 0 01.6 0z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicCloseIcon.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCloseIcon.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicCloseIcon svgRef={ref} {...props} />);
export default ForwardRef;
